import { Link } from "react-router-dom";
import S from "./style";

import TranslateStatic from "../../locales/TranslateStatic";
import Mete from "../../assets/ekip/mete.jpg";
import Batu from "../../assets/ekip/batu.jpg";
import Adil from "../../assets/ekip/adil.png";
import Suat from "../../assets/ekip/suat.png";
import Ayse from "../../assets/ekip/aysekendirci.png";
import Aysenur from "../../assets/ekip/aysenururfan.png";
import Gamze from "../../assets/ekip/gamze.png";
import Amilya from "../../assets/ekip/amilya.png";
import Senem from "../../assets/ekip/senem.png";
import Kifayet from "../../assets/ekip/MAHARRAMOVA.jpg";
import Oznur from "../../assets/ekip/oznursahin.png";
import Yeliz from "../../assets/ekip/yelizkeskin.png";
import Rabia from "../../assets/ekip/rabia.png";
import Suzan from "../../assets/ekip/suzanna.jpg";
import Ozlem from "../../assets/ekip/ozlem.jpeg";
import Semra from "../../assets/ekip/semra.jpeg";
import Safinur from "../../assets/ekip/safinur.png";
import Hulya from "../../assets/ekip/hulya.png";
import Levent from "../../assets/ekip/levent.png";
import Azime from "../../assets/ekip/azime-evci.png";
import Burcu from "../../assets/ekip/burcu.jpeg";
import Ceren from "../../assets/ekip/ceren.png";
import Avatar from "../../assets/ekip/user.png";
import Ozge from "../../assets/ekip/ozge.png";
import Ebral from "../../assets/ekip/ebral.png";
import Sahra from "../../assets/ekip/sahranur.png";
import Cansu from "../../assets/ekip/cansu.png";

export function Team() {
  return (
    <S.PageWrapper>
      {/* HERO SECTION */}
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="teamHeader" /></h1>
          <S.Breadcrumb>
            <Link to="/">
              <TranslateStatic string="home" />
            </Link>{" "}
            <span className="separator">/</span> 
            <span><TranslateStatic string="teamHeader" /></span>
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="hierarchy-container">
          
          {/* TIER 1 */}
          <div className="tier-row">
            <div className="team-avatar-card featured">
              <div className="avatar-wrapper">
                <img src={Mete} alt="Mete Işıkoğlu" />
              </div>
              <h2>
                <TranslateStatic string="MeteUnvan" /> Mete Işıkoğlu <TranslateStatic string="TitreMD" />
              </h2>
              <div className="desc">
                <p className="title-primary"><TranslateStatic string="MeteItitre" /></p>
                <p className="title-secondary"><TranslateStatic string="UyteSorumlusu" /></p>
              </div>
              <Link className="details-btn" to="/meteisikoglu">
                <TranslateStatic string="Ayrintilar" /> <span>➔</span>
              </Link>
            </div>
          </div>

          {/* TIER 2 */}
          <div className="tier-row">
            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Batu} alt="Dr. Batu Aydınuraz" /></div>
              <h2><TranslateStatic string="BatuUnvan" /> Dr. Batu Aydınuraz <TranslateStatic string="TitreMD" /></h2>
              <div className="desc"><p><TranslateStatic string="BatuAydinuraz" /></p></div>
              <Link className="details-btn" to="/batuaydinuraz"><TranslateStatic string="Ayrintilar" /> <span>➔</span></Link>
            </div>
            
            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Adil} alt="Prof. Dr. Adil Gökalp" /></div>
              <h2>Prof. Dr. Adil Gökalp</h2>
              <div className="desc"><p><TranslateStatic string="Adil" /></p></div>
              <Link className="details-btn" to="/adilgökalp"><TranslateStatic string="Ayrintilar" /> <span>➔</span></Link>
            </div>

            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Azime} alt="Dr. Azime Evci" /></div>
              <h2><TranslateStatic string="AzimeUnvan" /> Dr. Azime Evci</h2>
              <div className="desc"><p><TranslateStatic string="Azime" /></p></div>
              <Link className="details-btn" to="/azime"><TranslateStatic string="Ayrintilar" /> <span>➔</span></Link>
            </div>
          </div>

          {/* TIER 3 */}
          <div className="tier-row">
            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Ayse} alt="Dr. Ayşe Kendirci Çeviren" /></div>
              <h2>Dr. Ayşe Kendirci Çeviren</h2>
              <div className="desc"><p><TranslateStatic string="Ayse" /></p></div>
              <Link className="details-btn" to="/aysekendirciceviren"><TranslateStatic string="Ayrintilar" /> <span>➔</span></Link>
            </div>

            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Aysenur} alt="Ayşenur Avcı" /></div>
              <h2>Ayşenur Avcı</h2>
              <div className="desc"><p><TranslateStatic string="Aysenur" /></p></div>
              <Link className="details-btn" to="/aysenuravci"><TranslateStatic string="Ayrintilar" /> <span>➔</span></Link>
            </div>

            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Ceren} alt="Ceren Altınöz" /></div>
              <h2>Ceren Altınöz</h2>
              <div className="desc"><p><TranslateStatic string="Gamze" /></p></div>
            </div>

            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Ozge} alt="Özge Rabia Özkaya" /></div>
              <h2>Özge Rabia Özkaya</h2>
              <div className="desc"><p><TranslateStatic string="OzgeRabia" /></p></div>
            </div>
          </div>

          {/* TIER 4 */}
          <div className="tier-row">
            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Amilya} alt="Amilya Kibar" /></div>
              <h2>Amilya Kibar</h2>
              <div className="desc"><p><TranslateStatic string="Amilya" /></p></div>
            </div>

            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Senem} alt="Senem Aslanbaş" /></div>
              <h2>Senem Aslanbaş</h2>
              <div className="desc"><p><TranslateStatic string="Amilya" /></p></div>
            </div>

            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Ebral} alt="Ebral Çubukçu" /></div>
              <h2>Ebral Çubukçu</h2>
              <div className="desc"><p><TranslateStatic string="Amilya" /></p></div>
            </div>
          </div>

          {/* TIER 5 */}
          <div className="tier-row">
            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Yeliz} alt="Yeliz Gelen" /></div>
              <h2>Yeliz Gelen</h2>
              <div className="desc"><p><TranslateStatic string="Yeliz" /></p></div>
            </div>

            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Oznur} alt="Öznur Şahin Kotanak" /></div>
              <h2>Öznur Şahin Kotanak</h2>
              <div className="desc"><p><TranslateStatic string="Yeliz" /></p></div>
            </div>
          </div>

          {/* TIER 6 */}
          <div className="tier-row">
            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Sahra} alt="Sahra Nur Yılmaz" /></div>
              <h2>Sahra Nur Yılmaz</h2>
              <div className="desc"><p><TranslateStatic string="Rabia" /></p></div>
            </div>

            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Cansu} alt="Cansu Anatürk" /></div>
              <h2>Cansu Anatürk</h2>
              <div className="desc"><p><TranslateStatic string="Rabia" /></p></div>
            </div>
          </div>

          {/* TIER 7 */}
          <div className="tier-row">
            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Ozlem} alt="Özlem Demir" /></div>
              <h2>Özlem Demir</h2>
              <div className="desc"><p><TranslateStatic string="Ev idaresi" /></p></div>
            </div>

            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Semra} alt="Semra Köse" /></div>
              <h2>Semra Köse</h2>
              <div className="desc"><p><TranslateStatic string="Ev idaresi" /></p></div>
            </div>
          </div>

          {/* TIER 8 */}
          <div className="tier-row">
            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Safinur} alt="Safinur Akbay" /></div>
              <h2>Safinur Akbay</h2>
              <div className="desc"><p><TranslateStatic string="Kurumsal iletisim" /></p></div>
            </div>
          </div>

          {/* TIER 9 */}
          <div className="tier-row">
            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Hulya} alt="Hülya Kara" /></div>
              <h2>Hülya Kara</h2>
              <div className="desc"><p><TranslateStatic string="Hulya" /></p></div>
            </div>

            <div className="team-avatar-card">
              <div className="avatar-wrapper"><img src={Levent} alt="Av. Levent Geçerler" /></div>
              <h2>Av. Levent Geçerler</h2>
              <div className="desc"><p><TranslateStatic string="Levent" /></p></div>
            </div>
          </div>

        </div>
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
